import React from "react";
import coach from "../../../assets/images/coach_new.jpg";
import playergroup from "../../../assets/images/playergroup_new.jpg";
import singleplayer from "../../../assets/images/fans.jpg";

export const CoachesSection = () => {
  const payload = [
    {
      title: "Coaches",
      src: coach,
    },
    {
      title: "Athletes",
      src: playergroup,
    },
    {
      title: "Fans",
      src: singleplayer,
    },
  ];
  return (
    <div>
      <h1 className="connecting">Connecting</h1>
      <section className="feature-section coaches-section" id="foldthird">
        {payload?.map((item, index) => (
          <div className="feature-container coaches-container" key={index}>
            <div className="feature-container-item coaches-container-item">
              <div className="coaches-label-modify">{item.title}</div>
              <img className="category-image" src={item.src} />
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};
